export const genders = {
  'F': "หญิง",
  'M': "ชาย",
  'N': "ไม่ระบุเพศ"
}

export const educations = {
  1: "ประถมศึกษา",
  2: "มัธยมศึกษา",
  3: "ปริญญาตรี",
  4: "ปริญญาโท",
  5: "ปริญญาเอก",
  6: "ไม่ระบุ",
}

export const countrys = {
  2 : 'กรุงเทพมหานคร',
	1 : 'กระบี่',
	3 : 'กาญจนบุรี',
	4 : 'กาฬสินธุ์',
	5 : 'กำแพงเพชร',
	6 : 'ขอนแก่น',
	7 : 'จันทบุรี',
	8 : 'ฉะเชิงเทรา',
	9 : 'ชลบุรี',
	10 : 'ชัยนาท',
	11 : 'ชัยภูมิ',
	12 : 'ชุมพร',
	13 : 'เชียงราย',
	14 : 'เชียงใหม่',
	15 : 'ตรัง',
	16 : 'ตราด',
	17 : 'ตาก',
	18 : 'นครนายก',
	19 : 'นครปฐม',
	20 : 'นครพนม',
	21 : 'นครราชสีมา',
	22 : 'นครศรีธรรมราช',
	23 : 'นครสวรรค์',
	24 : 'นนทบุรี',
	25 : 'นราธิวาส',
	26 : 'น่าน',
	27 : 'บุรีรัมย์',
	28 : 'ปทุมธานี',
	29 : 'ประจวบคีรีขันธ์',
	30 : 'ปราจีนบุรี',
	31 : 'ปัตตานี',
	32 : 'พระนครศรีอยุธยา',
	33 : 'พะเยา',
	34 : 'พังงา',
	35 : 'พัทลุง',
	36 : 'พิจิตร',
	37 : 'พิษณุโลก',
	38 : 'เพชรบุรี',
	39 : 'เพชรบูรณ์',
	40 : 'แพร่',
	41 : 'ภูเก็ต',
	42 : 'มหาสารคาม',
	43 : 'มุกดาหาร',
	44 : 'แม่ฮ่องสอน',
	45 : 'ยโสธร',
	46 : 'ยะลา',
	47 : 'ร้อยเอ็ด',
	48 : 'ระนอง',
	49 : 'ระยอง',
	50 : 'ราชบุรี',
	51 : 'ลพบุรี',
	52 : 'ลำปาง',
	53 : 'ลำพูน',
	54 : 'เลย',
	55 : 'ศรีสะเกษ',
	56 : 'สกลนคร',
	57 : 'สงขลา',
	58 : 'สตูล',
	59 : 'สมุทรปราการ',
	60 : 'สมุทรสงคราม',
	61 : 'สมุทรสาคร',
	62 : 'สระแก้ว',
	63 : 'สระบุรี',
	64 : 'สิงห์บุรี',
	65 : 'สุโขทัย',
	66 : 'สุพรรณบุรี',
	67 : 'สุราษฎร์ธานี',
	68 : 'สุรินทร์',
	69 : 'หนองคาย',
	70 : 'หนองบัวลำภู',
	71 : 'อ่างทอง',
	72 : 'อำนาจเจริญ',
	73 : 'อุดรธานี',
	74 : 'อุตรดิตถ์',
	75 : 'อุทัยธานี',
	76 : 'อุบลราชธานี',
	77 : 'บึงกาฬ'
};

export const yearlists = Array.from(
  { length: 2024 - 1960 + 1 },
  (_, index) => 2500 + index
).reduce((prev, year) => {
	const yearText = year === 2500 ? '2500 หรือ น้อยกว่า' : `${year}`
	return {
		...prev,
		[year]: yearText,
	}
}, {})
